import React, { Component } from 'react';
import { DialogContent, Button, withStyles } from 'material-ui';
import EditPassengerStyles from './EditPassengerStyles';
import EditPassengerProps from './EditPassengerProps';
import TextField from '../../../../components/textField/TextField';
import Dictionary from '../../../../model/Dictionary';
import RelationshipDropdown from '../../../../components/passengers/relationshipDropdown/RelationshipDropdownContainer';
import PassengersScreenController from '../../PassengersScreenController';
import Checkbox from '../../../../components/checkbox/Checkbox';
import GenderSwitch from '../../../../components/genderSwitch/GenderSwitch';
import FlightsScreenController from '../../../flights/FlightsScreenController';
import Constants from '../../../../model/AppConfiguration';
import DateTimePickerWrapper from './DateTimePickerWrapper';
import EditPassengerHeader from './EditPassengerHeader';

/**
 * ## Redux imports
 */
import * as passengerActions from '../../../../redux/actions/PassengerActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../../redux/selectors/Index';

class EditPassenger extends Component {
  constructor (props) {
    super(props);

    this.state = {
      id: 0,
      relationshipType: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      infant: false, // !!props.infant
      gender: '',
      open: false,
      birthday: new Date(),
      birthdayPreview: FlightsScreenController.formatDateLongMonthWithDay(new Date()),
    };
    this.selectRelationshipType = PassengersScreenController.selectRelationshipType.bind(this);
  }

  componentWillReceiveProps (props) {
    const { passenger, selectedPassenger } = props;
    let parsedSelectedPassenger = parseInt(selectedPassenger, 10);
    let newSelectedPassenger =
      !!(selectedPassenger || selectedPassenger === 0) &&
      !!(parsedSelectedPassenger || parsedSelectedPassenger === 0);

    if (passenger && (passenger.id || passenger.id === 0) && newSelectedPassenger) {
      this.setState(passenger);
    }
  }

  handleCheckboxChange = name => e => {
    this.setState({ [ name ]: e.target.checked });
  };

  handleChange = name => e => {
    this.setState({ [ name ]: e.target.value });
  };

  selectDate = date => {
    this.setState({
      birthday: date,
      birthdayPreview: FlightsScreenController.formatDateLongMonthWithDay(date),
    });
  };

  render () {
    const { classes, handleClose, general } = this.props;
    const { id, relationshipType, firstName, lastName, email, phone } = this.state;
    return (
      <form className={classes.container} noValidate autoComplete='off'>
        <EditPassengerHeader
          handleClose={handleClose}
          title={id === 0 ? Dictionary.passenger.addTitle : Dictionary.passenger.editTitle}
        />
        <DialogContent>
          <TextField
            label={Dictionary.passenger.firstName}
            onChange={this.handleChange('firstName')}
            name='firstName'
            value={firstName}
          />
          <TextField
            fullWidth
            label={Dictionary.passenger.lastName}
            onChange={this.handleChange('lastName')}
            name='lastName'
            value={lastName}
          />
          <TextField
            label={Dictionary.passenger.phone}
            onChange={this.handleChange('phone')}
            name='phone'
            value={phone}
          />
          <TextField
            label={Dictionary.passenger.email}
            onChange={this.handleChange('email')}
            name='email'
            value={email}
          />
          <DateTimePickerWrapper
            label={Dictionary.passenger.birthday}
            date={this.state.birthday}
            viewDate={this.state.birthdayPreview}
            dateFormat={Constants.DATE_FORMAT}
            onChange={e => this.selectDate(e)}
          />
          <RelationshipDropdown
            relationshipType={relationshipType}
            selectRelationshipType={this.selectRelationshipType}
          />
          <Checkbox
            value={this.state.infant}
            onChange={this.handleCheckboxChange}
            name='infant'
            label={Dictionary.passenger.infant}
          />
          <GenderSwitch value={this.state.gender} onChange={this.handleChange('gender')} />

          <div style={{ width: '100%' }}>
            <Button
              style={{ width: '48.5%', marginRight: '1%' }}
              raised
              color='primary'
              onClick={() => this.props.actions.savePassenger(this.state, general, handleClose)}
            >
              {Dictionary.passenger.save}
            </Button>
            <Button style={{ width: '48.5%' }} onClick={handleClose}>
              {Dictionary.passenger.close}
            </Button>
          </div>
        </DialogContent>
      </form>
    );
  }
}

EditPassenger.propTypes = EditPassengerProps;

/**
 * ## Redux boilerplate
 */
const actions = [ passengerActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    general: selectors.general.getAll(state.general),
    passenger: selectors.passenger.getPassenger(state.passenger),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(EditPassengerStyles)(EditPassenger)
);



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/EditPassenger.js